import { render, staticRenderFns } from "./CollapseSublinks.vue?vue&type=template&id=460cbb36"
import script from "./CollapseSublinks.vue?vue&type=script&lang=js"
export * from "./CollapseSublinks.vue?vue&type=script&lang=js"
import style0 from "./CollapseSublinks.vue?vue&type=style&index=0&id=460cbb36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports